import React from 'react';
import propTypes from 'prop-types';
import { ModalLauncher } from '@metarouter-private/mr-mui';
import EditUserButton from './EditUserButton';
import UserModal from '../../modal/UserModal';

export default function EditUser({ row }) {
  return <ModalLauncher Launcher={EditUserButton} launcherProps={{ user: row }} Modal={UserModal} />;
}

EditUser.propTypes = {
  row: propTypes.object.isRequired,
};
